import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Label } from "components/bootstrap";
import { Timestamp } from "components/common";
import { formatTokenUsage } from "aiagent/utils";
import PaperSection from "security-app/components/Investigations/AIAgentTriageInvestigation/common/PaperSection";
const EVENT_LABEL = {
  agent_start: "Agent started",
  tool_call: "Tool call",
  tool_result: "Tool result",
  tool_failure: "Tool failure",
  agent_finish: "Agent finished",
  agent_error: "Agent error"
};
const Heading = styled.h3(
  ({ theme }) => css`
    margin: ${theme.spacings.lg} 0 ${theme.spacings.sm};
  `
);
const EventList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xs};
`;
const EventHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacings.sm};
  flex-wrap: wrap;
`;
const Meta = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `
);
const PayloadBlock = styled.pre(
  ({ theme }) => css`
    margin: ${theme.spacings.sm} 0 0;
    padding: ${theme.spacings.xs};
    background: ${theme.colors.global.background};
    border: 1px solid ${theme.colors.cards.border};
    border-radius: ${theme.spacings.xxs};
    max-height: 320px;
    overflow: auto;
    font-size: ${theme.fonts.size.tiny};
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  `
);
const prettyJson = (raw) => {
  if (!raw) {
    return "";
  }
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
};
const TraceEventItem = ({ event }) => {
  var _a;
  const [expanded, setExpanded] = useState(false);
  const hasPayload = !!(event.arguments || event.response || event.error);
  const tokens = event.token_usage ? formatTokenUsage(event.token_usage) : null;
  const title = (_a = EVENT_LABEL[event.type]) != null ? _a : event.type;
  return /* @__PURE__ */ React.createElement(
    PaperSection,
    {
      title,
      titleAs: "h5",
      bsSize: "xs",
      header: /* @__PURE__ */ React.createElement(EventHeader, null, /* @__PURE__ */ React.createElement(Meta, null, "#", event.seq), /* @__PURE__ */ React.createElement(Label, { uppercase: true }, title), event.name && /* @__PURE__ */ React.createElement("strong", null, event.name), /* @__PURE__ */ React.createElement(Meta, null, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: event.timestamp })), event.duration_ms !== void 0 && event.duration_ms !== null && /* @__PURE__ */ React.createElement(Meta, null, event.duration_ms, " ms"), tokens && /* @__PURE__ */ React.createElement(Meta, null, tokens), hasPayload && /* @__PURE__ */ React.createElement(Meta, null, expanded ? "hide" : "show", " details")),
      collapsible: hasPayload,
      defaultClosed: true,
      onCollapse: (wasOpened) => setExpanded(!wasOpened),
      disableCollapseButton: !hasPayload
    },
    event.arguments && /* @__PURE__ */ React.createElement(PayloadBlock, null, prettyJson(event.arguments)),
    event.response && /* @__PURE__ */ React.createElement(PayloadBlock, null, event.response),
    event.error && /* @__PURE__ */ React.createElement(PayloadBlock, null, event.error)
  );
};
const TraceSection = ({ entry }) => {
  if (!entry.trace || entry.trace.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Heading, null, "Trace (", entry.trace.length, " events)"), /* @__PURE__ */ React.createElement(EventList, null, entry.trace.map((event) => /* @__PURE__ */ React.createElement(TraceEventItem, { key: event.seq, event }))));
};
export default TraceSection;
